import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  numDifferentiation,
  titleCase,
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../common/app_constant";
import {
  ALL_CONTACT_PERSON,
  ENV,
  s3_bucket_prod_url,
  s3_bucket_uat_url,
  SUB_DIRECTORY,
} from "../../../../common/constant";
// import Blog from "../../../../component/blog";
import {
  actionDownload,
  actionGetPolicyDashboard,
  actionGetPolicyInactive,
  resetDownloadPolicyResponse,
  resetGetPolicyInactiveResponse,
  resetGetPolicyResponse,
} from "../dashboard/store";
import { actionGetPolicyList, resetGetPolicyList, actionSourceForEnquiry, resetGetSource } from "./store";
import _ from "lodash";
import {
  actionPolicyCompanyList,
  resetPolicyCompanyList,
} from "../my_profile/store";
import { useRef } from "react";
import Loader from "../../../../component/page_loader";
import CustomerFeedback from "../../../../component/customer_feedback";
import InfromationCard from "../../../../component/information_card";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import PolicyCard from "../../../../component/policy_card";
import Contact from "../../../../component/contact";

const Policies = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const {
    control,
    formState: { errors },
    register,
  } = useForm();
  const { getPolicy, downloadPolicy } = useSelector(state => ({
    ...state.dashboardStore,
  }));

  const { policyCompanyList } = useSelector(state => ({
    ...state.MyProfileStore,
  }));

  // policy list

  const { getPolicyList, getSource } = useSelector(state => ({
    ...state.policyStore,
  }));

  const [allPolicy, setAllPolicy] = useState([]);
  const [policyActive, setPolicyActive] = useState([]);
  const [policyInActive, setPolicyInActive] = useState([]);
  const [selectedItem, setSelectedItem] = useState("A");
  const [filterArr, setFilterArr] = useState([]);
  const [searchPolicy, setSearchPolicy] = useState(null);
  const [clicked, setClicked] = useState("0");
  const contentEl = useRef();
  const [userDetails, setUserDetails] = useState();

  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("all");
  const [clientListArr, setClientList] = useState([]);
  const [isCustomerFeedback, setIsCustomerFeedback] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [policyDetails, setPolicyDetails] = useState([]);
  const [filteredPolicyDetails, setFilteredPolicyDetails] = useState([]);
  const [featuresDescriptionMap, setFeaturesDescriptionMap] = useState(null);
  const [userZone, setUserZone] = useState("");
  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDetails(userData);
    }
  }, []);

  useEffect(() => {
    if (userDetails != null) {
      dispatch(
        actionGetPolicyList({
          user_id: userDetails?.id,
        })
      );
    }
  }, [userDetails]);

  // const data = [
  //   {
  //     value: "all",
  //     text: "ALL",
  //     icon: (
  //       <img
  //         src="assets/images/categories/insurance.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "AVIATION",
  //     text: "AVIATION",
  //     icon: (
  //       <img
  //         src="assets/images/categories/aviation_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "ENERGY",
  //     text: "ENERGY",
  //     icon: (
  //       <img
  //         src="assets/images/categories/energy_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "ENGINEERING",
  //     text: "ENGINEERING",
  //     icon: (
  //       <img
  //         src="assets/images/categories/engineering_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "HEALTH",
  //     text: "HEALTH",
  //     icon: (
  //       <img
  //         src="assets/images/categories/health_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "LIABILITY",
  //     text: "LIABILITY",
  //     icon: (
  //       <img
  //         src="assets/images/categories/liability_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "MARINE",
  //     text: "MARINE",
  //     icon: (
  //       <img
  //         src="assets/images/categories/marine_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "MISCELLENOUS",
  //     text: "MISCELLENOUS",
  //     icon: (
  //       <img
  //         src="assets/images/categories/miscellaneous_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "MOTOR",
  //     text: "MOTOR",
  //     icon: (
  //       <img
  //         src="assets/images/categories/motorcycle_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  //   {
  //     value: "PROPERTY",
  //     text: "PROPERTY",
  //     icon: (
  //       <img
  //         src="assets/images/categories/property_ins.png"
  //         height="15"
  //         width="15"
  //       />
  //     ),
  //   },
  // ];

  const exportToCSV = (apiData, fileName) => {
    const columnsToInclude = [
      "company_name",
      "department_name",
      "policy_type_name",
      "insurer_name",
      "policy_no",
      "policy_start_date",
      "policy_expiry_date",
      "sum_insured",
      "net_premium",
      "tpp_amount",
      "service_tax",
      "gross_premium",
      "rm_name"
    ];

    const headers = {
      company_name: "Company Name",
      department_name: "Department Name",
      policy_type_name: "Policy Type",
      insurer_name: "Insurer Name",
      policy_no: "Policy Number",
      policy_start_date: "Policy Start Date",
      policy_expiry_date: "Policy Expiry Date",
      sum_insured: "IDV",
      net_premium: "Net Premium",
      tpp_amount: "TPP Amount",
      service_tax: "Service Tax",
      gross_premium: "Gross Premium",
      rm_name: "RM Name",
    };

    const filteredData = apiData.map(row =>
      columnsToInclude.reduce((acc, column) => {
        acc[column] = row[column];
        return acc;
      }, {})
    );

    const ws = XLSX.utils.json_to_sheet(filteredData, {
      header: Object.keys(headers),
      skipHeader: false,
    });
    XLSX.utils.sheet_add_aoa(ws, [Object.values(headers)], { origin: "A1" });

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  useEffect(() => {
    if (policyCompanyList !== null) {
      dispatch(resetPolicyCompanyList());
      if (policyCompanyList.result === true) {
        setClientList(policyCompanyList.response);
      } else {
        // setClientList([])
        switch (policyCompanyList.status) {
          default:
        }
      }
    }
  }, [policyCompanyList]);

  useEffect(() => {
    const loginData = localStorage.getItem("userData");
    console.log("Raw login data:", loginData);
  
    if (loginData) {
      try {
        const user = JSON.parse(loginData);
        console.log("Parsed user:", user);
  
        const zoneName = user?.userCity?.cityState?.stateZone?.name;
        console.log("Extracted zone:", zoneName);
  
        if (zoneName) {
          setUserZone(zoneName.toUpperCase());
        }
      } catch (err) {
        console.error("Error parsing login data from localStorage", err);
      }
    }
  }, []);
  
  
 
  // Debug
  console.log("Zone:", userZone);
  

  

  useEffect(() => {
    if (selectedDepartment != null) {
      // dispatch(
      //   actionPolicyCompanyList({ department_name: selectedDepartment })
      // );
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedItem === "A") {
      setAllPolicy(policyActive);
      setFilterArr(policyActive);
    }
    if (selectedItem === "I") {
      setAllPolicy(policyInActive);
      setFilterArr(policyInActive);
    }
  }, [selectedItem, policyActive, policyInActive]);

  useEffect(() => {
    if (getPolicy !== null) {
      dispatch(resetGetPolicyResponse());
      if (getPolicy?.result === true) {
        setAllPolicy(getPolicy.response);
        var today = moment().format("YYYY-MM-DD");

        var policyActiveArr = [];
        var policyInActiveArr = [];
        getPolicy.response.map((item, index) => {
          if (item.policy_expiry_date >= today) {
            policyActiveArr.push(item);
          } else {
            policyInActiveArr.push(item);
          }
        });
        setPolicyActive(policyActiveArr);
        setPolicyInActive(policyInActiveArr);
        setIsLoader(false);
      } else {
        setIsLoader(false);
        switch (getPolicy.status_code) {
          case 400:
            toast.error(getPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [getPolicy]);

  useEffect(() => {
    if (getPolicyList !== null) {
      dispatch(resetGetPolicyList());
      if (getPolicyList?.status === true) {
        setFilteredPolicyDetails(getPolicyList?.data?.policyList);
        // setFeatureMasters(getPolicyList?.data?.featureMasters);
        if (
          getPolicyList &&
          getPolicyList.data?.policyList &&
          getPolicyList.data?.policyList.length > 0 // Check if policyList array is not empty
        ) {
          let temp = {};
          getPolicyList.data.policyList.forEach(policy => {
            policy?.plan?.planFeatures.forEach(feature => {
              temp[feature.name.trim().toLowerCase()] = feature?.detail;
            });
          });
          setFeaturesDescriptionMap(temp);
        }
        setPolicyDetails(getPolicyList?.data?.policyList);
        setIsLoader(false);
      } else {
        setIsLoader(false);
        switch (getPolicyList?.status_code) {
          case 400:
            toast.error(getPolicyList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [getPolicyList]);

  // useEffect(()=>{
  //   if(getSource){
  //     dispatch(resetGetSource());
  //     if(getSource.status===true){
  //       // alert(getSource.data?.source)
  //         const token = localStorage.getItem("token");     
  //         // const url = `http://localhost:3001?token=${token}&source=${getSource.data?.source}`;
  //         // window.open(url);
  //         // window.location.href = url;
  //     }
  //   }
  // },[getSource])

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        window.open(downloadPolicy.data.url);
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigation("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  // const handleToggle = (index) => {
  //   if (clicked === index) {
  //     return setClicked("0");
  //   }
  //   setClicked(index);
  // };

  // const renderDocuments = (item) => {
  //   var arrDoc = [];

  //   item != null && item.length > 0
  //     ? item.map((item, index) => {
  //         arrDoc.push(
  //           <div className="col-md-6">
  //             <div className="card">
  //               <div className="card-body d-flex justify-content-between">
  //                 <div className="col-10">
  //                   <p className="mb-0">{item.actual_uploaded_file_name}</p>
  //                   <small>
  //                     {moment(item.created_at).format("DD/MM/YYYY")}
  //                   </small>
  //                 </div>
  //                 <div className="col-2 text-center">
  //                   <i
  //                     className="fa fa-download cursor-pointer"
  //                     onClick={(e) => {
  //                       e.preventDefault();
  //                       dispatch(actionDownload({ dms_id: item.dms_id }));
  //                     }}
  //                   />
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         );
  //       })
  //     : arrDoc.push(
  //         <div class="col-md-12">
  //           <div class="card">
  //             <div class="card-body">No Documents Uploaded</div>
  //           </div>
  //         </div>
  //       );

  //   return arrDoc;
  // };

  // const renderEndorsement = (item) => {
  //   var arrEndorsement = [];

  //   item != null && item.length > 0
  //     ? item.map((item, index) => {
  //         arrEndorsement.push(
  //           <div class="col-md-12">
  //             <div class="card">
  //               <div class="card-body">
  //                 <a
  //                   class=" w-100"
  //                   data-bs-toggle="collapse"
  //                   href={`#collapseExample${index}`}
  //                   role="button"
  //                   aria-expanded="false"
  //                   aria-controls={`collapseExample${index}`}
  //                 >
  //                   <div class="d-flex">
  //                     {/* <div class="col-1 text-center my-auto">
  //                                           <i class="fa fa-download "></i>
  //                                       </div> */}
  //                     <div class="col-10">
  //                       <p class="mb-0">{item.policy_type}</p>
  //                       <small>Endorsement NO. : {item.endo_no}</small>
  //                     </div>
  //                   </div>
  //                 </a>
  //                 <div class="collapse" id={`collapseExample${index}`}>
  //                   <div class="row border-top pt-2 mt-1">
  //                     <div class="col-6 mt-2">
  //                       <label class="card-label">Policy Type :</label>
  //                       <p class="card-value mb-0">{item.policy_type}</p>
  //                     </div>
  //                     <div class="col-6 mt-2">
  //                       <label class="card-label">Insure Company</label>
  //                       <p class="card-value mb-0"> {item.insurer_name}</p>
  //                     </div>
  //                     <div class="col-6 mt-2">
  //                       <label class="card-label">Endorsement Executive</label>
  //                       <p class="card-value mb-0"> {item.csc_name}</p>
  //                     </div>
  //                     <div class="col-6 mt-2">
  //                       <label class="card-label">RM Name</label>
  //                       <p class="card-value mb-0">{item.rm_name}</p>
  //                     </div>
  //                     <div class="col-6 mt-2">
  //                       <label class="card-label">Status</label>
  //                       <p class="card-value mb-0">{item.status}</p>
  //                     </div>
  //                     <div class="col-6 mt-2">
  //                       <label class="card-label">Department</label>
  //                       <p class="card-value mb-0"> {item.department}</p>
  //                     </div>
  //                   </div>
  //                   <div class="row border-top pt-2 mt-1">
  //                     <div class="col-md-4 fw-bold border-end">
  //                       Net Premium:{" "}
  //                       <span>{numDifferentiation(item.net_premium)}</span>
  //                     </div>
  //                     <div class="col-md-4 fw-bold border-end">
  //                       GST: <span>{numDifferentiation(item.service_tax)}</span>
  //                     </div>
  //                     <div class="col-md-4 fw-bold ">
  //                       Total Premium:{" "}
  //                       <span>{numDifferentiation(item.gross_premium)}</span>
  //                     </div>
  //                   </div>
  //                   <div class="row border-top pt-2 mt-1">
  //                     <div class="col-md-6 fw-bold border-end">
  //                       Created On:{" "}
  //                       <span>
  //                         {moment(item.created_at).format("DD/MM/YYYY")}
  //                       </span>
  //                     </div>
  //                     <div class="col-md-6 fw-bold border-end">
  //                       Modified On:{" "}
  //                       <span>
  //                         {moment(item.updated_at).format("DD/MM/YYYY")}
  //                       </span>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         );
  //       })
  //     : arrEndorsement.push(<></>);

  //   return arrEndorsement;
  // };
  // const renderProgressBar = (item) => {
  //   var date1 = moment(new Date()).format("YYYY-MM-DD");
  //   var date2 = moment(item?.policy_expiry_date);
  //   var days = date2.diff(date1, "days");

  // return (
  //   <>
  //     <p class="fw-600 mb-0">{days} Days left</p>
  //     <div class="progress">
  //       <div
  //         class="progress-bar"
  //         role="progressbar"
  //         style={{ width: `${days}%` }}
  //         aria-valuenow="135"
  //         aria-valuemin="0"
  //         aria-valuemax="100"
  //       ></div>
  //     </div>
  //   </>
  // );
  // };
  const renderPolicy = () => {
    var policyArr = [];

    filteredPolicyDetails != null && filteredPolicyDetails?.length > 0 ? (
      filteredPolicyDetails.map((item, index) => {
        policyArr.push(
          <div className="accordion">
            <div className="col-12 mt-3 position-relative" key={index}>
              <PolicyCard
                detail={item}
                detailIndex={index}
                actionDownload={actionDownload}
                allPolicies={filteredPolicyDetails} 
                featuresDescriptionMap={featuresDescriptionMap}
              />
            </div>
          </div>
        );
      })
    ) : (
      <></>
    );
    return policyArr;
  };

  const onOpenPosKaito = () => {
    dispatch(actionSourceForEnquiry())

    // const token = localStorage.getItem("token");
    // const url = `http://localhost:3001?token=${token}`;
    // window.open(url);
    // window.location.href = url;
  }

  return (
    <>
      <div className="row mt-6 ">
        <div className="col-12 mb-3">
          <div>
            <div className="d-flex">
              <h5 className="mb-0"> Policies</h5>
              {/* <button className="btn btn-sm btn-primary2 ms-3" onClick={onOpenPosKaito}> Get Quote</button> */}
            </div>
          </div>
          <div>
            {/* <button
              class="btn btn-success btn-sm"
              onClick={() => {
                exportToCSV(filteredPolicyDetails, "Policy data");
              }}
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </button> */}
          </div>
        </div>
        <div className="col-12 col-md-8">
          {isLoader === true ? (
            <Loader />
          ) : (
            <>
              <div className="">
                {/* <div class="col-md-3">
                  <div class="card-body">
                    <Controller
                      control={control}
                      name="category"
                      render={({ field: { value, onChange } }) => (
                        <Select
                          placeholder="Select Option"
                          defaultValue={data[0]}
                          options={data}
                          isSearchable={true}
                          onChange={(e) => {
                            dispatch(
                              actionGetPolicyDashboard({
                                department_name: e.value,
                                client_id: selectedCompanyId,
                              })
                            );
                            const selectedDepartment = e?.value;
                            setSelectedDepartment(selectedDepartment);
                          }}
                          getOptionLabel={(e) => (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {e.icon}
                              <span style={{ marginLeft: 5 }}>{e.text}</span>
                            </div>
                          )}
                        />
                      )}
                    />
                  </div>
                </div> */}
                <div class="card profile-section col-12">
                  <div class="card-body">
                    <form>
                      <div class="form-group has-search">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input
                          type="text"
                          name="search"
                          className="form-control"
                          placeholder={"Search Policy"}
                          value={searchPolicy}
                          onChange={event => {
                            setSearchPolicy(event.target.value);
                            var arrFilteredPolicies = Object.assign(
                              [],
                              policyDetails
                            );
                            if (event.target.value?.length > 0) {
                              var arrFilteredPolicies =
                                arrFilteredPolicies.filter(
                                  item =>
                                    (item.policy_no &&
                                      item.policy_no
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        )) ||
                                    (item.insurer_name &&
                                      item.insurer_name
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        )) ||
                                    (item.vehicle_no &&
                                      item.vehicle_no
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        )) ||
                                    (item.customer_name &&
                                      item.customer_name
                                        .toLowerCase()
                                        .includes(
                                          event.target.value.toLowerCase()
                                        ))
                                );
                              setFilteredPolicyDetails(arrFilteredPolicies);
                            } else {
                              setFilteredPolicyDetails(arrFilteredPolicies);
                            }
                          }}
                        />
                      </div>
                    </form>
                  </div>
                </div>
                {/* <div class="col-md-2 my-auto mt-2 mt-md-auto text-center">
                  <button
                    class="btn btn-primary btn-sm"
                    onClick={() => {
                      navigation("/policy-wallet/add-policy-wallet");
                    }}
                  >
                    Add Policy
                  </button>
                </div> */}
              </div>
            </>
          )}
        </div>
        <div className="col-12">
          <div className="mt-4  row justify-content-between tab-menu">
            <div className="col-12 col-md-6">
              <button
                className={`btn btn-light btn-sm ${selectedItem === "A" ? "active" : ""
                  }`}
                onClick={() => {
                  setClicked(null);
                  setSelectedItem("A");
                }}
              >
                All Policy({`${filteredPolicyDetails?.length}`})
              </button>
              {/* <button
                          className={`btn btn-light btn-sm ${
                            selectedItem === "I" ? "active" : ""
                          }`}
                          style={{
                            marginLeft: 14,
                          }}
                          onClick={() => {
                            setClicked(null);
                            setSelectedItem("I");
                          }}
                        >
                          Expired ({`${policyInActive?.length}`})
                        </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row pb-5 mt-1">
        <div className="col-12 col-md-9">
          {filteredPolicyDetails != null && filteredPolicyDetails.length > 0 ? (
            <div className="row">{renderPolicy()}</div>
          ) : (
            <div className="d-flex justify-content-center align-items-center mt-5">
              <h5>No Policies To Display</h5>
            </div>
          )}
        </div>
        <div className="col-12 col-md-3">
        <Contact zone={userZone} />

        </div>
      </div>
    </>
  );
};

export default Policies;
